import React from "react";
import { SVG } from "@/assets/svg";
import styles from "@/component/header/header.module.css";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import { googleSignup } from "../header/login.api";
import { useAppContext } from "@/context";
import { useRouter } from "next/router";
import DefaultLoader from "../loader";
import { createPayment } from "@/utils/apis/payment/create-payment.api";
import { deleteAccount } from "@/utils/apis/auth/delete-account.api";

type Props = {
  handleLoginPopupClose: () => void;
};

function GoogleSignUpContent({ handleLoginPopupClose, selectedPackageObj }: any) {
  const router = useRouter();
  const [loading, setLoading] = React.useState<boolean>(false);
  const { fetchUser, setUser } = useAppContext();
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setLoading(true);

      const user = tokenResponse;
      try {
        if (selectedPackageObj?.amount === "0") {
          const response = await googleSignup({
            access_token: tokenResponse.access_token,
            packageId: "675fb8633e890165358ca232", // assigning the rockhound package in the beginning so if the user leave the process, it won't be the paid version
          });
          if (response.data.success) {
            setUser(response.data.data);
            fetchUser();
            router.replace("/dashboard");
          }
        } else {
          const response = await googleSignup({
            access_token: tokenResponse.access_token,
            packageId: "675fb8633e890165358ca232", // assigning the rockhound package in the beginning so if the user leave the process, it won't be the paid version
          });
          const res = await createPayment({
            amount: selectedPackageObj?.amount,
            name: selectedPackageObj?.packageName,
            planId: selectedPackageObj?._id,
            email: response?.data?.data?.email,
            customerName: `${response?.data?.data?.firstName} ${response?.data?.data?.lastName}`,
          });
          if (res.data.success) {
            localStorage.setItem(
              "userDetails",
              JSON.stringify({
                ...response,
                packageId: selectedPackageObj?._id,
              })
            );

            window.open(res.data.url, "_self");
          }
          // if (response.data.success) {
          //   // fetchUser();
          //   // handleLoginPopupClose();
          //   // router.replace(`/dashboard`);
          // }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    onError: console.log,
  });

  return (
    <button
      className={`${styles.googleLogin}`}
      type="button"
      onClick={() => login()}
    >
      {loading ? (
        <DefaultLoader color="#557eff" />
      ) : (
        <>
          <SVG.Google width="40px" />
          <span className={`${styles.google}`}>Google</span>
        </>
      )}
    </button>
  );
}

export default function GoogleSignUp(props: any) {
  const CLIENT_ID = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || "73335520973-1sh0o14spsv5p54l71fommbik7chqshg.apps.googleusercontent.com";
  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <GoogleSignUpContent {...props} />
    </GoogleOAuthProvider>
  );
}
